$(function() {
	if ($('#lending-tree-form')[0]) {
        // Mask fields
		$("#phone").mask("999-999-9999", {autoclear: false});
        $("#ssn").mask("999-99-9999", {autoclear: false});
        
        var validator = $('#lending-tree-form').validate({
            rules: {
                phone: {
                    phoneUS: true
                },
                ssn: {
                    social_security_number: true
                },
            },
            highlight: function(element) {
                $(element).closest('.form-row').removeClass('success').addClass('error');
            },
            errorPlacement: function(error, element) {
                $(element).closest('.form-row').append(error);
            },
            success: function(element) {
                $(element).closest('.form-row').removeClass('error').addClass('success');
            }
        });
	}
});
